import { Archive } from 'lucide-react';

export function ArchivedPropertyNotice() {
  return (
    <aside
      className="border-line bg-card-alt mb-6 flex gap-3 rounded-lg border px-5 py-4"
      role="status"
    >
      <div className="bg-ink/5 text-ink-soft flex size-9 shrink-0 items-center justify-center rounded-full">
        <Archive size={17} aria-hidden />
      </div>
      <div>
        <p className="text-ink text-sm font-semibold">Historischer Datensatz</p>
        <p className="text-ink-soft mt-0.5 text-sm">
          Dieses Apartment ist archiviert und schreibgeschützt. Finance und Audit bleiben für
          Nachweise erreichbar.
        </p>
      </div>
    </aside>
  );
}
